import React   from 'react'
import { withStyles } from '@material-ui/core/styles'
import { getRequest, getMenu }  from '../reducers/asciidoc/action'
import { withRouter} from "react-router-dom"
import { connect } from 'react-redux'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import '../../assets/style/getStarted.scss'
import Cookies from 'universal-cookie'
import query from '../../util/urlUtil'

const cookies = new Cookies();

const styles = theme => ({
    tab: {
        color: '#702F8A',
        '&:hover': {
            color: 'black'
        },
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        },
        fontWeight: 300,
        minWidth: '90px',
        width: '90px'
    },
    indicator: {
        backgroundColor:'#702F8A'
    },
});

class GetStarted extends React.Component {

    state = {
        value: '',
        menuAdocs: null
    };

    UNSAFE_componentWillMount() {
      const menuAdocs = cookies.get('menu_adocs');
      if(menuAdocs) {
          const value = query('adoc') ? query('adoc') : Object.keys(menuAdocs)[0];
          this.setState({ menuAdocs: menuAdocs });
          this.setState({ value: value });
      } else {
          this.props.history.push('/');
      }
  }


  bindMenu = () => {
    if(document.getElementById('toc')) {
      let tableContent = document.querySelector('.sectlevel1').innerHTML || '';
      document.getElementById('toc').remove();
      document.getElementById('tableContent-legacy').innerHTML = tableContent;
    }
  };

  componentDidMount() {
      this.bindMenu();
  }

  componentDidUpdate() {
    this.bindMenu();
  }

  handleChange = (event, value) => {
      const { getRequest } = this.props;
      const { menuAdocs } = this.state;
      this.setState({ value });
      getRequest(menuAdocs[value].href);
  };

  render() {
      const { getRequest, asciiDocHtml, classes, getMenu } = this.props;
      const { value, menuAdocs } = this.state;

      if(!menuAdocs) {
          getMenu();
      }

      if(!asciiDocHtml && menuAdocs) {
          getRequest(menuAdocs[this.state.value].href);
      }


      return (
          <div className="root-all">
            <div className="get-started-banner"><h2>Get started with our APIs</h2></div>
              <div className="row" id="ascii-content">
                  <div className="col-md-4 col-lg-3" id="ascii-menu-left-legacy">
                      {menuAdocs &&
                          <Tabs value={value} onChange={this.handleChange} classes={{indicator: classes.indicator}} className="tabs-app" variant="scrollable" scrollButtons="auto">
                              {
                                  Object.keys(menuAdocs).map(function (key) {
                                      return <Tab value={key} label={menuAdocs[key].title}
                                                  className={`${classes.tab} ${key === value ? 'tab-active' : ''}`}/>
                                  })
                              }
                          </Tabs>
                      }
                      <ul id="tableContent-legacy"/>
                  </div>

                  <div style={{top: "180px", height: "height: calc(100% - 250px)", bottom: "0"}} className="col-md-12 col-lg-9" dangerouslySetInnerHTML={{ __html: asciiDocHtml }} id="asciiDocContent"/>
              </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
    return {asciiDocHtml : state.Asciidoc.asciiDocHtml.results, menuAdocs: state.Asciidoc.asciiDocHtml.results }
}

const mapDispatchToProps = {
    getRequest,
    getMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(GetStarted)))
